import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import {useEffect, useState} from "react";
import axios from "axios";
import "../../../assets/css/pages/product.css";
import button from "../../../Components/Buttons/Button";

const BundleCard = () => {
  const {product, dispatch, errors, data} = useNewProduct();

  const handleProductChange = (event, index) => {
    dispatch({
      type: TYPES.SET_PRODUCT,
      payload: {
        ...product,
        bundle: product.bundle.map((item, numbering) => {
          return numbering === index ? {
            ...item,
            product_id: parseInt(event.target.value),
          } : item
        })
      }
    })
  }

  const handlePriceChange = (event, index) => {
    dispatch({
      type: TYPES.SET_PRODUCT,
      payload: {
        ...product,
        bundle: product.bundle.map((item, numbering) => {
          return numbering === index ? {
            ...item,
            price: event.target.value
          } : item
        })
      }
    })
  }

  const handleMoreProduct = () => {
    if (product.bundle == null || (product.bundle != null && product.bundle.length < 3)) {
      dispatch({
        type: TYPES.SET_PRODUCT,
        payload: {
          ...product,
          bundle: [...product.bundle, {
            product_id: data?.shopProducts?.map((productItem, index) => {
              return product.bundle.some(item => item.id !== productItem.id) && productItem.id
            }).find(newItem => newItem !== false),
            price: 0.00
          }]
        }
      })
    }
  }

  const handleProductFieldRemoval = (event, index) => {
    dispatch({
      type: TYPES.SET_PRODUCT,
      payload: {
        ...product,
        bundle: product.bundle.filter((item, numbering) => numbering !== parseInt(index))
      }
    })
  }

  return (
    <div className="card card-flush py-4">
      <div className="card-header">
        <div className="card-title">
          <h2>Bundle</h2>
        </div>
      </div>

      <div className="card-body pt-0">
        <div className="mb-10 fv-row">
          {
            product.bundle && product.bundle.map((bundleItem, index) => (
              <>
                <div key={index} className="d-flex gap-3">
                  <div className="w-50">
                    <label className="required form-label">Product</label>
                    <select className="form-select mb-2" data-control="select2" data-hide-search="true"
                            data-placeholder="Select an option"
                            id="kt_ecommerce_add_product_status_select"
                            onChange={(event) => handleProductChange(event, index)}
                            value={bundleItem?.product_id || ''}
                    >
                      <option>Choose Seller Product</option>
                      {
                        data?.shopProducts?.map((shopProduct, index) => (
                          <option key={index} value={shopProduct.id}>
                            {shopProduct.name}
                          </option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="w-50">
                    <label className="required form-label">Product Bundle Price</label>
                    <input type="number" className="form-control mb-2"
                           placeholder="Choose Product Bundle Price" value={bundleItem.price}
                           onChange={event => handlePriceChange(event, index)}
                    />
                  </div>
                  <button
                    type="button"
                    onClick={event => handleProductFieldRemoval(event, index)}
                    className="btn btn-danger btn-hover-scale btn-size"
                  >
                    -
                  </button>
                </div>
                {
                  errors.hasOwnProperty(`products.${index}.product_id`) && (
                    errors[`products.${index}.product_id`].map((item, index) => (
                      <div key={index} className="fs-7 mb-7 text-danger">{item}</div>
                    ))
                  )
                }
              </>
            ))
          }

          <button type="button" data-repeater-create=""
                  className="btn btn-sm btn-light-primary"
                  onClick={handleMoreProduct}
          >
                            <span className="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="24" height="24" viewBox="0 0 24 24"
                                     fill="none">
                                    <rect opacity="0.5" x="11" y="18" width="12"
                                          height="2" rx="1"
                                          transform="rotate(-90 11 18)"
                                          fill="black"/>
                                    <rect x="6" y="11" width="12" height="2"
                                          rx="1" fill="black"/>
                                </svg>
                            </span>
            Add another Product
          </button>
          <div className="text-muted fs-7 mt-3">Select seller in General tab in order to see relevant
            products
          </div>
          <div className="text-muted fs-7 mt-3">Enter the product and price</div>
        </div>
      </div>
    </div>
  )
}

export default BundleCard;